<div class="wrapper">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-3">
                        <a (click)="add()" [class.disabled]="create" class="btn btn-sm btn-primary" style="color: white;">Add New Intelligent</a>
                    </div>
                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item active">Intelligent List</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Intelligent List</h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
                            <i class="fas fa-minus"></i></button>
                    </div>
                </div>
                <div class="card-body p-0 mt-2">
                    <table class="table table-striped projects" *ngIf="loadTable" datatable>
                        <thead>
                            <tr>
                                <th style="width: 5%">
                                    SNo
                                </th>
                                <th style="width: 15%">
                                    Date
                                </th>
                                <th style="width: 40%">
                                    Intelligent Name
                                </th>
                                <th style="width: 15%">
                                    Intelligent Icon
                                </th>
                                <th style="width: 15%">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of intelligent_list;let i = index;">
                                <td>{{ i + 1 }}</td>
                                <td>{{ data.date_time | date: "dd-MM-yyyy" }}</td>
                                <td><a>{{ data.IntelligentName }}</a></td>
                                <td><img src="{{data.IntelligentIcon}}" alt="Intelligent" width="20px" height="20px"></td>
                                <td class="project-actions text-right">
                                    <a *ngIf="data.Status == 'Active'" [class.disabled]="edit" class="btn btn-info btn-sm" data-toggle="modal" data-target="#exampleModalCenter" style="color: white;" (click)="open(data.id,data.IntelligentName,data.IntelligentIcon)">
                                        <i class="fas fa-pencil-alt">
                                        </i> Edit
                                    </a>&nbsp;
                                    <a *ngIf="data.Status == 'Active'" [class.disabled]="del" class="btn btn-danger btn-sm" style="color: white;" (click)="delete(data.id,'Inactive','You will not be able to recover this Intelligent Details!','Yes, delete it!')">
                                        <i class="fas fa-trash">
                                        </i> Delete
                                    </a>
                                    <a *ngIf="data.Status == 'Inactive'" [class.disabled]="del" class="btn btn-success btn-sm" style="color: white;" (click)="delete(data.id,'Active','You will Activate this Intelligent Details!','Yes, Activate it!')">
                                        <i class="far fa-check-circle"></i> Activate
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
    <app-footer></app-footer>
</div>
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="exampleModalLongTitle">Update Intelligent</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="myform">
                    <div class="form-group">
                        <label for="inputName">Intelligent Name</label>
                        <input type="text" id="inputName" class="form-control" formControlName="intelligent_name" [ngClass]="{ 'is-invalid': submitted && f.intelligent_name.errors }">
                        <div *ngIf="submitted && f.intelligent_name.errors" class="invalid-feedback">
                            <div *ngIf="f.intelligent_name.errors.required">Intelligent Name is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputName">Intelligent Icon (20px * 20px)</label>
                        <div class="group-gap">
                            <div class="avatar-upload">
                                <div class="avatar-edit">
                                    <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
                                </div>
                                <div class="avatar-preview">
                                    <div class="preview" *ngIf="imageUrl && imageUrl !== null">
                                        <img [src]="imageUrl" width="20px" height="20px">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="row">
                    <div class="col-12">
                        <input type="submit" value="Update" class="btn btn-success" data-dismiss="modal" (click)="submit()">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>